import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b7efd62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card border-0 d-none d-md-flex card--no-hover border-bottom rounded-0\" data-v-3b7efd62><div class=\"card-body px-0\" data-v-3b7efd62><div class=\"row gx-0\" data-v-3b7efd62><div class=\"col-5 align-middle leading\" data-v-3b7efd62>Name und Förderprogramm</div><div class=\"col-3 align-middle leading\" data-v-3b7efd62>Bereich</div><div class=\"col-1 align-middle leading\" data-v-3b7efd62>Bundesland</div><div class=\"col-3 align-middle leading\" data-v-3b7efd62>Förderung</div></div></div></div>", 1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "card-body p-2" }
const _hoisted_5 = { class: "row gx-0 border-bottom pb-2 mb-n2" }
const _hoisted_6 = { class: "col-12 col-md-5 d-flex align-items-center" }
const _hoisted_7 = { class: "content-left d-flex" }
const _hoisted_8 = { class: "fw-bold ms-1 ms-md-0 fs-5 pe-2 d-flex d-sm-inline" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = { class: "popper-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 ps-1"
}, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "align-middle ps-1 ps-sm-0"
}
const _hoisted_13 = { class: "d-none d-md-flex card-body--subtitle text-color--low-emphasis" }
const _hoisted_14 = { class: "content-right d-flex d-md-none align-items-center ms-1" }
const _hoisted_15 = { class: "align-middle area card-body--subtitle text-color--low-emphasis" }
const _hoisted_16 = { class: "col-12 col-md-3 d-flex align-items-center d-none d-md-flex" }
const _hoisted_17 = { class: "content-right d-flex align-items-center" }
const _hoisted_18 = { class: "align-middle area fs-5 circle-text pe-1" }
const _hoisted_19 = { class: "col-12 col-md-1 d-none d-md-flex align-items-center" }
const _hoisted_20 = { class: "fs-5" }
const _hoisted_21 = { class: "col-12 col-md-3 d-none d-md-flex align-items-center" }
const _hoisted_22 = {
  key: 0,
  class: "list-unstyled fs-5 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_ctx.iconToggle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measures, (measure, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card flex-row rounded-0 border-0 ms-n2 me-n2 bg-transparent rounded-2",
            key: index,
            onClick: ($event: any) => (_ctx.navigateTo(measure.id, measure.label))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(measure.label), 1),
                        (measure.additionalService)
                          ? (_openBlock(), _createBlock(_component_Popper, {
                              key: 0,
                              hover: "",
                              arrow: "",
                              "append-to-body": "true",
                              placement: "top",
                              class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, " Zugeordnete Grundmaßnahme: " + _toDisplayString(measure.additionalServiceLabel), 1)
                              ]),
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (measure.code)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " | " + _toDisplayString(measure.code), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(measure.supportProgramm.label), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", {
                          class: "circle d-block rounded-circle me-1",
                          style: _normalizeStyle('background-color:' + measure.measureType.color)
                        }, null, 4),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(measure.measureType.label), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", {
                      class: "circle d-block rounded-circle me-1",
                      style: _normalizeStyle('background-color:' + measure.measureType.color)
                    }, null, 4),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(measure.measureType.label), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(measure.federalState.code), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (measure.measureBonus.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.measureBonus, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.getMeasureBonusItemOutput(item, true)), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 8, _hoisted_3))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}